/**
 * OAuth redirect URI must exactly match:
 * 1) the URL Snapchat/Google/LinkedIn redirect back to
 * 2) the value sent in token exchange
 * 3) the value whitelisted in each platform's developer console
 */
export const getOAuthRedirectUri = () => {
  if (typeof window !== 'undefined' && window.location?.origin) {
    const path = window.location.pathname.split('?')[0].replace(/\/$/, '');

    if (path.endsWith('/client/settings/integrations')) {
      return `${window.location.origin}${path}`;
    }
  }

  const configured = (process.env.REACT_APP_REDIRECT_URL || '').trim();
  if (configured) {
    return configured;
  }

  if (typeof window !== 'undefined' && window.location?.origin) {
    const publicUrl = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
    return `${window.location.origin}${publicUrl}/client/settings/integrations`;
  }

  return '';
};

/**
 * Remove OAuth query params from the URL so refresh/back does not reprocess the code.
 */
export const clearOAuthCallbackParams = (navigate) => {
  if (typeof window === 'undefined') {
    return;
  }

  const path = window.location.pathname;

  if (typeof navigate === 'function') {
    navigate(path, { replace: true });
    return;
  }

  window.history.replaceState({}, document.title, path);
};

export const clearLinkedInOAuthState = () => {
  if (typeof window === 'undefined') {
    return;
  }

  localStorage.removeItem('selected_platform_to_connect');
  localStorage.removeItem('account_type');
  localStorage.removeItem('linkedin_code');
  localStorage.removeItem('code');
};

export const clearInstagramOAuthState = () => {
  if (typeof window === 'undefined') {
    return;
  }

  localStorage.removeItem('selected_platform_to_connect');
  localStorage.removeItem('instagram_code');
};

export const getFacebookAccountType = (socialMediaType) =>
  socialMediaType === 'organic_social' ? 'posts' : 'ads';

export const clearFacebookOAuthState = () => {
  if (typeof window === 'undefined') {
    return;
  }

  localStorage.removeItem('selected_platform_to_connect');
  localStorage.removeItem('account_type');
  localStorage.removeItem('facebook_code');
};

export const clearSnapchatOAuthState = () => {
  if (typeof window === 'undefined') {
    return;
  }

  localStorage.removeItem('selected_platform_to_connect');
  localStorage.removeItem('snapchat_code');
};
